import cx from 'classnames';
import { ReactNode } from 'react';

import style from './Section.module.css';

type SectionVariant = 'cover' | 'breadcrumb' | 'introduction' | 'default';

const variantClass: Record<SectionVariant, string> = {
    cover: style.variantCover,
    breadcrumb: style.variantBreadcrumb,
    introduction: style.variantIntroduction,
    default: style.variantDefault,
};

type SectionBackground = 'neutral' | 'primary-dark';

const bgColorClass: Record<SectionBackground, string> = {
    neutral: style.neutral,
    'primary-dark': style.primaryDark,
};

type SectionProps = {
    children: ReactNode;
    id: string;
    variant?: SectionVariant;
    bgColor?: SectionBackground;
    className?: string;
};

export function Section({ children, id, variant = 'default', bgColor, className }: SectionProps) {
    return (
        <section
            id={id}
            className={cx(
                style.section,
                variantClass[variant],
                bgColor && cx(variant !== 'cover' && style.sectionBg, bgColorClass[bgColor]),
                className,
            )}
        >
            {children}
        </section>
    );
}
